module.exports = __webpack_public_path__ + "img/eicraproicon.bf8a155a.png";